<template lang="pug">
	
	.badass-album
		.presentation
			p.text(v-html="translate('badass.badass_album_1')")
		
		.quote
			blockquote(v-html="translate('badass.quote_1')")
			p.translation(v-html="translate('badass.traduction_1')")

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import { TweenMax } from 'gsap'
	import Globals from '~utils/Globals.js'
	import Scrollable from '~abstracts/scrollable'
	

  	@Component({
		name: 'BadassAlbum',
		components: { },
		data: function () {
			return {
				state : Globals.state
			}
		},
		computed : {
			isMobile: function () {
				return this.state.isMobile
			},
			isTablet: function () {
				return this.state.isTablet
			}
		}
	})

	class BadassAlbum extends Scrollable {

		mounted () {
			super.mounted()
			

			this._dom()
		}

		init () {
			super.init()

		}

		_bind () {
			super._bind()
		}

		_dom () {
			
		}

		_intervals () {
			
			// this.tlScroll = new TimelineMax({paused: true})
		
			// this.scroller.interval('badass.album.timeline',{
			// 	start:this.bounds.top,
			// 	end: this.bounds.top + this.bounds.height,
			// 	exec:(e) => {
			// 		if(!e.isInside) return
			// 		this.tlScroll.progress(e.ratio)
			// 	}
			// })

		}

		_points () {

		}

		_resize () {
			super._resize()

			this._intervals()
			this._points()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default BadassAlbum

</script>


<style lang="stylus">
	
	@import '../../../theme/utils'
	@import '../../../theme/variables'
	
	.badass-album
		width 100%
		position relative
		padding-bottom 70px

		.presentation
			max-width 720px
			margin auto
			text-align center

			+break(minlg)
				max-width 1000px

			.text
				color #fff
				font-family $FONT_THIRDLY
				font-weight 700
				font-size em(20px)
				line-height em(50px,20px)

				span,a
					text-decoration underline
					font-family $FONT_PRIMARY
					font-weight 400
					color #fff
		
		.quote
			max-width 1100px
			margin auto
			text-align center

			+break(minlg)
				max-width 1400px
			
			blockquote
				font-size em(56px)
				line-height 1.2em
				color #fff
				font-family $FONT_PRIMARY
				font-weight 700
				margin-top 60px

				+break(xs)
					font-size em(40px)

			.translation
				color #fff
				font-family $FONT_SECONDARY
				font-size em(15px)
				line-height em(21px,15px)
				letter-spacing .15em
				max-width 560px
				margin auto
				margin-top 50px
				text-transform uppercase

	
</style>


// WEBPACK FOOTER //
// badass-album.vue?c2d697ca